export default __webpack_public_path__ + "static/media/coupon-use.75d06ff6.jpeg";